"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
/**
 * Returns true if str case-insensitively contains substr or
 * if substr is the empty string. Otherwise returns false.
 * @param {String} str - The string that is searched within
 * @param {String} substr - The string that is searched for
 */
const stringContainsSubstring = function () {
  var _context;
  let str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let substr = arguments.length > 1 ? arguments[1] : undefined;
  return !substr || (0, _includes.default)(_context = str.toLowerCase()).call(_context, substr.toLowerCase());
};
var _default = exports.default = stringContainsSubstring;